module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add","doCreateChildren":"Create child posts","doCreateVariant":"Generate text","factsToGenerate":"Generate facts","generateDescription":"Generate description","generateTitle":"Generate title","pickCoverImage":"Pick cover image","pickProducts":"Pick products","post":"Post (or update an existing post)","selectImage":"Select section image","section":"Section"}}')
  delete Component.options._Ctor
}
